import { AfterViewInit, Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { ICellRendererParams } from 'ag-grid-enterprise';
import { ObservableService } from '../../../../app/services/observable.service';

@Component({
  selector: 'app-filter-the-click-table',
  templateUrl: './filter-the-click-table.component.html',
  styleUrls: ['./filter-the-click-table.component.css'],
  standalone: true
})
export class FilterTheClickTableComponent implements AfterViewInit {
  params: any;
  createdBy: any;
  customCreatedBy: any;
  email!: string | undefined;
  constructor(private observableService: ObservableService) {}
  @ViewChild('content', { static: false }) container?: ElementRef;

  @ViewChild('trigger') button: any;

  ngAfterViewInit(): void {}

  agInit(params: any) {
    this.params = params;
  }

  filterCreatedByTable(createdBy: any) {
    console.log('createdBy', createdBy);

    this.createdBy = createdBy;
    const customFilter = {
      customCreatedBy: this.createdBy
    };
    this.observableService.filterChange.emit(customFilter);
  }
}
